import React from 'react';
import {
  Typography,
  Box
} from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell
} from 'recharts';
import { Card } from 'Components/Card';

interface DataItem {
  name: string;
  value: number;
  color?: string;
}

interface CardBarHorizontalProps {
  title: string;
  data: DataItem[];
  barColor?: string;
  valueLabel?: string;
}

const CardBarHorizontal: React.FC<CardBarHorizontalProps> = ({
                                                               title,
                                                               data,
                                                               barColor = '#0039c4',
                                                               valueLabel = 'Valor'
                                                             }) => {
  return (
    <Card>
      <Typography variant="subtitle1" fontWeight="bold" className="mb-4">
        {title}
      </Typography>

      <Box width="100%" height={215}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart layout="vertical" data={data}>
            <XAxis type="number" domain={[0, 100]} tickFormatter={(v) => `${v}%`} />
            <YAxis
              type="category"
              dataKey="label"
              width={120}
              tick={{ fontSize: 12 }}
            />
            <Tooltip
              formatter={(value: number) => [`${value.toFixed(2)}%`, valueLabel]}
              labelFormatter={(label: string) => `${label}`}
            />
            <Bar dataKey="value" barSize={18}>
              {data.map((entry, index) => (
                <Cell
                  key={index}
                  fill={entry.color || barColor}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Card>
  );
};

export default CardBarHorizontal;
